import { render } from "./BeneficiariosCrearActualizarComponent.vue?vue&type=template&id=50f62a9c"
import script from "./BeneficiariosCrearActualizarComponent.vue?vue&type=script&lang=js"
export * from "./BeneficiariosCrearActualizarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/tesoreria_tolima/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__